import { Component, Input, OnInit } from '@angular/core';
import { TypeLoadingGif } from '@app/enums';
/**
  Componente que muestra una animación de carga (loading) en la interfaz de usuario.
  Este componente permite personalizar el tipo de animación de carga y decidir si debe bloquear
  toda la pantalla o solo una parte de ella.
**/
@Component({
    selector: 'app-am-loading',
    templateUrl: './am-loading.component.html',
    styleUrls: ['./am-loading.component.scss'],
    standalone: false
})
export class AmLoadingComponent implements OnInit {

/**
    Indica si la animación de carga debe bloquear toda la pantalla.
    @type {boolean}
    @default false
  **/
    @Input() blockScreen: boolean = false;

    /**
      Tipo de animación de carga que se mostrará.
      @type {TypeLoadingGif}
      @default 'FOOTER_LOADING'
    **/
    @Input() typeLoading: TypeLoadingGif = 'FOOTER_LOADING';
  
    /**
      Constante que representa el tipo de animación de carga para un componente.
      @type {string}
    **/
    COMPONENT_LOADING = 'COMPONENT_LOADING';
  
    /**
      Constante que representa el tipo de animación de carga para el pie de página.
      @type {string}
    **/
    FOOTER_LOADING = 'FOOTER_LOADING';
  
  constructor(
  ) { }

  ngOnInit(): void {
  }

}
